export class FieldMappingLimitsModel {
    updatesDone;
    updatesAllowed;
}
//# sourceMappingURL=field-mapping-limits.js.map